import { Table } from "@tanstack/react-table"
import { Button } from "../ui/button"
import { ChevronLeft, ChevronRight } from "lucide-react"

const TablePageNavigationButtons = ({ table }: { table: Table<any> }) => {
    return (
        <div className="flex items-center justify-end gap-2">
            <Button
                aria-description="Previous Page"
                variant="outline"
                size="sm"
                className="flex items-center gap-2 text-muted-foreground"
                onClick={() => table.previousPage()}
                disabled={!table.getCanPreviousPage()}
            >
                <ChevronLeft className="w-4 h-4" />
                <span className="hidden md:block">Previous Page</span>
            </Button>
            <Button
                aria-description="Next Page"
                variant="outline"
                size="sm"
                onClick={() => table.nextPage()}
                disabled={!table.getCanNextPage()}
                className="flex items-center gap-2 text-muted-foreground"
            >
                <span className="hidden md:block">Next Page</span>
                <ChevronRight className="w-4 h-4" />
            </Button>
        </div>
    )
}

export default TablePageNavigationButtons
